import React, { FC } from "react";

import { Job } from "../../assets/images";
import {
  Bookmark,
  Clock,
  Global,
  Pin,
  Star,
  Verified,
} from "../../assets/icons";

import "./RecommendedJob.scss";

interface Props {
  job: {
    employer: {
      id: number;
      company_name: string;
      rating: number;
      images: {
        banner_image: string;
        profile_image: string;
      };
    };
    id: string;
    is_saved: boolean;
    job_type: string[];
    location: string;
    posted_since: string;
    skills: string[];
    title: string;
    work_place_type: string[];
  };
}

const RecommendedJob: FC<Props> = ({ job }: Props) => {
  return (
    <div className="recommendedJob">
      <Bookmark className="recommendedJob__bookmark" />
      <img
        src={job.employer.images.profile_image}
        alt="job"
        width="78px"
        height="78px"
      />
      <div className="name">
        {job.employer?.company_name} <Verified />
      </div>
      <div className="rating">
        {Array.from({ length: job.employer.rating }, (_, index) => (
          <Star key={index} />
        ))}
      </div>
      <div className="title">{job.title}</div>
      <div className="line"></div>
      <div className="details">
        <div>
          <Pin />
          <span>{job.location}</span>
        </div>
        <div>
          <Global />
          <span>{job.job_type.map((type) => type).join(" • ")}</span>
        </div>
        <div>
          <Clock />
          <span>{job.posted_since}</span>
        </div>
      </div>
      <div className="buttons">
        <button
          className="invert"
          onClick={() =>
            window.open(
              `${process.env.REACT_APP_MAIN_URL}/job/${job.id}`,
              "_blank"
            )
          }
        >
          View Job
        </button>
      </div>
    </div>
  );
};

export default RecommendedJob;